// PageWrapper.js
import React, { useState, useEffect } from "react";
import { Box, Fade, Fab } from "@mui/material";
import { FaChevronUp } from "react-icons/fa";
import Footer from "./Footer";
import { settings } from "../data/settings";
import { useLocation } from "react-router-dom";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <Fade in={visible}>
      <Fab
        onClick={scrollToTop}
        size="small"
        sx={{
          position: "fixed",
          bottom: 32,
          right: 32,
          backgroundColor: "black",
          color: "white",
          "&:hover": {
            backgroundColor: "#333",
          },
          zIndex: 1000,
        }}
        aria-label="Scroll to top"
      >
        <FaChevronUp />
      </Fab>
    </Fade>
  );
};

const PageWrapper = ({ children }) => {
  return (
    <Box
      sx={{
        marginTop: settings?.navbar.height,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
      <ScrollToTopButton />
    </Box>
  );
};

export default PageWrapper;
